import { useState, useEffect, useMemo } from "react"
import { Box, Container, InputAdornment, Typography, TextField } from '@material-ui/core';
import { Pagination } from '@mui/material';
import { Search } from "@material-ui/icons"
import { gcAPI } from "../services/GroupCategoryService";
import CardProduct from "../components/Card/CardProduct";

const Product = () => {
    const [search, setSearch] = useState(null)
    const [page, setPage] = useState(0)
    const [data, setData] = useState([])
    const [userData, setUserData] = useState([])
    const [userEditData, setUserEditData] = useState([])
    const [filterGroup, setFilterGroup] = useState(null)

    useEffect(() => {
        (async () => {
            try {
                const { status, message: { User, Category } } = await gcAPI.getCategory({})
                if (status != 200) throw { message: "Server Error." }
                if (User instanceof Array && Category instanceof Array) {
                    setData(Category)
                    setUserData(User)
                }

            } catch (error) {
                alert(error.message)
            }
        })()
        return () => {
            setData([])
            setUserData([])
        }
    }, [])

    useEffect(() => {
        setPage(0)
    }, [search, filterGroup])

    const handleChangePage = (e, NewPage) => {
        setPage(NewPage - 1)
    }

    const showData = useMemo(() => {
        let Show = []
        for (let index = 0; index < data.length; index++) {
            const element = data[index];
            if (element.brand instanceof Array) {
                for (let bindex = 0; bindex < element.brand.length; bindex++) {
                    const brand = element.brand[bindex];
                    let Retail = userData.find((res) => res.username == brand.retail)
                    let Buyer = userData.find((res) => res.username == brand.buyer)
                    Show.push({ Category: element.Category, Group: element.Group, Brand: brand.name, buyer: { ...Buyer }, retail: { ...Retail } })
                }
            }
        }
        return Show
    }, [data, userData])

    const groupData = useMemo(() => {
        let newData = data.reduce((prev, curr) => {
            let same = prev.find((res) => res == curr.Group)
            if (!same) {
                prev.push(curr.Group)
            }
            return prev
        }, [])
        return newData
    }, [data])

    const filterSearch = (res) => {
        let string = res.Category.concat(res.Group, res.Brand, res?.buyer?.fullname, res?.buyer?.username, res?.buyer?.table, res?.retail?.fullname, res?.retail?.username, res?.retail?.table)
        if (!search) return true
        else return string.toLowerCase().includes(search.toLowerCase())
    }

    const filterGroupZ = (res) => {
        if (!filterGroup) return true
        else return res.Group == filterGroup
    }

    const maxPage = Math.ceil(showData.filter(filterSearch).filter(filterGroupZ).length / 12)

    return (
        <>
            <Container className="container-product">
                <Typography variant="h5" gutterBottom component="div" >
                    รายชื่อผู้ดูแลสินค้า Comseven
                </Typography>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        '& .MuiTextField-root': { width: '350px' },
                    }}
                >
                    <TextField variant="outlined" label="ค้นหา" style={{ margin: 'auto' }} color="primary"
                        value={search || ""}
                        onChange={(e) => setSearch(e.target.value)}
                        InputProps={{
                            startAdornment: <InputAdornment position="start"><Search /></InputAdornment>,
                        }} />
                </Box>
                <Box className="filter-product">
                    <Box className={`filter-list-product ${!filterGroup ? "filter-select-product" : ""}`} onClick={() => setFilterGroup(null)}>All</Box>
                    {groupData.map((res) => (<Box className={`filter-list-product ${filterGroup == res ? "filter-select-product" : ""}`} key={res} onClick={() => setFilterGroup(res)}>{res}</Box>))}
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        flexWrap: 'wrap'
                    }}
                >
                    {showData.filter(filterSearch).filter(filterGroupZ).sort((a, b) => a.Group.toUpperCase() - b.Group.toUpperCase()).slice(page * 12, page * 12 + 12).map((res, i) => (
                        <CardProduct key={i} page={page} res={res} userEditData={userEditData} setUserEditData={setUserEditData} setData={setData} setUserData={setUserData} />
                    ))}
                </Box>
                {maxPage > 0 && <Pagination count={maxPage} page={page + 1} onChange={handleChangePage} sx={{ ["& .MuiPagination-ul"]: { justifyContent: 'center !important', marginTop: '24px' } }} />}
            </Container>
        </>
    )
}

export default Product